import React, { useState } from 'react';
import Img from '../../Img';
import ImgPreviewModal from '../../../views/app/common/modal/ImgViewModal';

interface TableColumnModalImgProps {
  url: string;
  width?: number;
  height?: number;
}

const TableColumnModalImg = (props: TableColumnModalImgProps) => {
  const { url, width = 80, height = 80 } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      {url ? <Img style={{ width: `${width}px`, height: `${height}px` }} src={url} /> : <>-</>}
      <ImgPreviewModal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} data={{ url }} />
    </>
  );
};

export default TableColumnModalImg;
